// extracted by mini-css-extract-plugin
export default {"shortcutsWrapper":"ShortcutsManager_shortcutsWrapper__BKzwS"};